export const timeDifference = (date1: any, date2: any) => {
  const now = date2 || new Date();
  const startDate = new Date(date1);
  const endDate = new Date(now);

  let timeDiff = Math.abs(endDate.getTime() - startDate.getTime());

  const months = Math.floor(timeDiff / (1000 * 3600 * 24 * 30));
  timeDiff -= months * 1000 * 3600 * 24 * 30;

  const days = Math.floor(timeDiff / (1000 * 3600 * 24));
  timeDiff -= days * 1000 * 3600 * 24;

  const hours = Math.floor(timeDiff / (1000 * 3600));
  timeDiff -= hours * 1000 * 3600;

  const minutes = Math.floor(timeDiff / (1000 * 60));

  const seconds = Math.floor(timeDiff / 1000);

  let result = "";
  if (months > 0) {
    result += `${months} month${months > 1 ? "s" : ""}, `;
  }
  if (days > 0 || months > 0) {
    result += `${days} day${days > 1 ? "s" : ""}, `;
  }
  if (hours > 0 || days > 0 || months > 0) {
    result += `${hours} hour${hours > 1 ? "s" : ""}`;
  }
  if (minutes > 0 && hours === 0) {
    result += ` ${minutes} minute${minutes > 1 ? "s" : ""}`;
  }
  if (seconds > 0 && hours === 0 && minutes === 0) {
    result += `${seconds} second${seconds > 1 ? "s" : ""}`;
  }
  if (minutes > 0 && hours > 0) {
    result += ` and ${minutes} minute${minutes > 1 ? "s" : ""}`;
  } else if (seconds > 0 && minutes > 0 && hours > 0) {
    result += ` and ${minutes} minute${minutes > 1 ? "s" : ""}`;
  }

  return result.trim();
};
